import { AbstractControl, UntypedFormArray, ValidatorFn } from '@angular/forms';

export const atLeastOneItemInvoiced: ValidatorFn = (target: AbstractControl) =>
  (target.get('items') as UntypedFormArray)?.controls.some(item => !!item.get('amountToInvoice')?.value)
    ? null
    : { atLeastOneItemInvoiced: true };
